var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{attrs:{"small":"","color":_vm.status === 'paid'
      ? '#07C07E1A'
      : _vm.status === 'unpaid'
      ? '#E71D1D26'
      : '#f2f2f7'}},[_c('span',{staticClass:"p-3 font-weight-bold",style:(_vm.status === 'paid'
        ? 'color: #07C07E'
        : _vm.status === 'unpaid'
        ? 'color: #E71D1D'
        : 'color: #797997')},[_vm._v(" "+_vm._s(_vm.status)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }